import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import DeleteModal from '@/components/Modals/DeleteModal';
import Code from '@/images/Code.svg';
import DocumentText from '@/images/DocumentText.svg';
import Trash from '@/images/Trash.svg';
import { Button, theme } from '@de-id/ui-components';
import styled from '@emotion/styled';
import { useState } from 'react';

const ConfigureTabFooterContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    & > button:last-of-type {
        margin-left: auto;
    }
`;

const DeleteButton = styled(Button)`
    color: ${theme.colors.white};
`;

const SubmitButton = styled(Button)`
    :disabled {
        background-color: ${theme.colors.secondary[200]};
        color: ${theme.colors.white};
    }
`;

interface Props {
    view: 'form' | 'json';
    onViewChange: (view: 'form' | 'json') => void;
    onDelete?: () => void;
    onContinue: () => void;
}

export const ConfigureTabFooter = ({ view, onViewChange, onDelete, onContinue }: Props) => {
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

    const handleModeChange = () => {
        if (view === 'form') {
            onViewChange('json');
        } else {
            onViewChange('form');
        }
    };

    return (
        <ConfigureTabFooterContainer>
            <Button size="small" color="outlined" onClick={handleModeChange}>
                <MaskedIcon src={view === 'form' ? Code : DocumentText} size="16px" />
                {view === 'form' ? 'View as JSON' : 'Edit as Form'}
            </Button>
            {onDelete && (
                <>
                    <DeleteButton size="small" color="warning" onClick={() => setDeleteConfirmationOpen(true)}>
                        <MaskedIcon src={Trash} size="16px" />
                        Delete Webhook
                    </DeleteButton>

                    <DeleteModal
                        itemType="webhook"
                        mode="square"
                        open={deleteConfirmationOpen}
                        isLoading={false}
                        onDelete={async () => await onDelete()}
                        onClose={() => setDeleteConfirmationOpen(false)}
                        text={{
                            title: 'Confirm delete',
                            content: `Are you sure you want to delete this Webhook endpoint? This action cannot be undone.`,
                            cta: 'Delete endpoint',
                        }}
                    />
                </>
            )}

            <SubmitButton size="small" color="secondary" onClick={onContinue}>
                Continue
            </SubmitButton>
        </ConfigureTabFooterContainer>
    );
};
